/* eslint-disable import/prefer-default-export */
export default function getSportsSubtitle(title) {
  const parts = title.split(':')

  if (parts.length > 1) {
    return parts.slice(1).join(':')
  }

  return ''
}
